/**
 * 股票相关
 */
import api from '@/api'

let stock = {}

stock.getIndustries = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/stock/industries`, formData)
}

stock.getCategories = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/stock/categories`, formData)
}

stock.getAreas = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/stock/areas`, formData)
}


stock.getFocus = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/stock/focus`, formData)
}

stock.getFocusDetail = async function (formData) {
    // console.log("future.getLongShort===",formData);
    return api.get(`/stock/focusDetail`, formData)
}


// stock.klines = async function (formData) {
//     return api.get(`/stock/klines`, formData)
// }

// stock.recommendList = async function (formData) {
//     return api.get(`/stock/recommendList`, formData)
// }

// stock.synckLines = async function (formData) {
//     return api.get(`/stock/synckLines`, formData)
// }

// stock.checkSignal = async function (formData) {
//     return api.get(`/stock/checkSignal`, formData)
// }



export default stock
